import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Event } from './models/event.model';

const EVENTS: readonly Event[] = [
  {
    title: 'Informando a Gestão Pública: como o ARP facilita a realização de pesquisas',
    description:
      'Na 10ª edição do CGDados Apresenta, recebemos dois pesquisadores da área de Administração Pública para relatarem suas experiências com o Ambiente Remoto de Pesquisa da Enap.',
    url: 'https://www.youtube.com/watch?v=M7b3v3guEf8',
    provider: 'YouTube',
    thumbnail: 'https://i.ytimg.com/vi/M7b3v3guEf8/mqdefault.jpg',
    createdAt: '2025-06-01T12:00:00.000Z',
  },
  {
    title: 'Análise da Lei de Cotas',
    description:
      'Na 9ª edição do CGDados Apresenta, compartilhamos nossa pesquisa acerca da eficiência da política de cotas no Poder Executivo Federal.',
    url: 'https://www.youtube.com/watch?v=i34G8oXurME',
    provider: 'YouTube',
    thumbnail: 'https://i.ytimg.com/vi/i34G8oXurME/mqdefault.jpg',
    createdAt: '2025-05-01T12:00:00.000Z',
  },
  {
    title: 'Perspectivas de regulação da IA',
    description:
      'Na 8ª edição do CGDados Apresenta, debatemos o papel do Estado, do setor produtivo e da sociedade na construção de um marco regulatório para o uso de Inteligência Artificial.',
    url: 'https://www.youtube.com/watch?v=HMqI2j_EH98',
    provider: 'YouTube',
    thumbnail: 'https://i.ytimg.com/vi/HMqI2j_EH98/mqdefault.jpg',
    createdAt: '2025-04-01T12:00:00.000Z',
  },
  {
    title: 'Ambiente Remoto de Pesquisa',
    description:
      'Na 7ª edição do CGDados Apresenta, abordamos o Ambiente Remoto de Pesquisa (ARP), uma iniciativa que garante acesso seguro e controlado a bases de dados sigilosas para fins de pesquisa aplicada.',
    url: 'https://www.youtube.com/watch?v=zn0hWmUNwaY',
    provider: 'YouTube',
    thumbnail: 'https://i.ytimg.com/vi/zn0hWmUNwaY/mqdefault.jpg',
    createdAt: '2025-03-01T12:00:00.000Z',
  },
  {
    title: 'DataCuidados',
    description:
      'Na 6ª edição do CGDados Apresenta, compartilhamos os processos de desenvolvimento do Painel DataCuidados, realizado em parceria com o Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome.',
    url: 'https://www.youtube.com/watch?v=oWGJBA3xOOA',
    provider: 'YouTube',
    thumbnail: 'https://i.ytimg.com/vi/oWGJBA3xOOA/mqdefault.jpg',
    createdAt: '2025-02-01T12:00:00.000Z',
  },
  {
    title: 'Tabelas de Remuneração de Cargos e Carreiras do Poder Executivo Federal',
    description:
      'Na 5ª edição do CGDados Apresenta, compartilhamos o processo de consolidação da base de dados de tabelas de remuneração de carreiras do Poder Executivo Federal e perspectivas futuras.',
    url: 'https://www.youtube.com/watch?v=zD-BQMh6Yss',
    provider: 'YouTube',
    thumbnail: 'https://i.ytimg.com/vi/zD-BQMh6Yss/mqdefault.jpg',
    createdAt: '2025-01-01T12:00:00.000Z',
  },
  {
    title: 'Histórico de análise e uso de IA na PNDP',
    description:
      'Na 4ª edição do CGDados Apresenta, os analistas da CGDados apresentaram o histórico da análise e do uso de Inteligência Artificial com os dados da Política Nacional de Desenvolvimento de Pessoas.',
    url: 'https://www.youtube.com/watch?v=dXz56eJaAUE',
    provider: 'YouTube',
    thumbnail: 'https://i.ytimg.com/vi/dXz56eJaAUE/mqdefault.jpg',
    createdAt: '2024-12-01T12:00:00.000Z',
  },
  {
    title: 'Mobilidade no setor público',
    description:
      'Na 2ª edição do CGDados Apresenta, nossa equipe compartilhou uma análise sobre servidores federais concursados que participam de novos concursos para mudar de cargo.',
    url: 'https://www.youtube.com/watch?v=GKPXWn-m5SM',
    provider: 'YouTube',
    thumbnail: 'https://i.ytimg.com/vi/GKPXWn-m5SM/mqdefault.jpg',
    createdAt: '2024-10-01T12:00:00.000Z',
  },
];

@Injectable({ providedIn: 'root' })
export class EventosService {
  getEvents(): Observable<readonly Event[]> {
    return of(EVENTS);
  }
}
